import { defaultTo, find, isNil } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { GcfMockData } from 'src/utils/gcf-helper';

import {
  type CustomerStateItem,
  CUSTOMER_STATE_ITEMS,
} from './AssemblyStatesButtonGroup.constants';
import {
  AssemblyButton,
  AssemblyButtonGroup,
} from './AssemblyStatesButtonGroup.styled';

interface IProps {
  setCustomerState: (customerState: Partial<GcfMockData>) => void;
  customerState?: Partial<GcfMockData>;
}

export const AssemblyStatesButtonGroup = ({
  setCustomerState,
  customerState,
}: IProps) => {
  const getSelectedStateId = useMemo(
    () =>
      (state?: Partial<GcfMockData>): number => {
        if (isNil(state)) return 0;
        const item = find(CUSTOMER_STATE_ITEMS, (item) => item.state === state);

        return defaultTo(item?.id, 0);
      },
    [],
  );

  const [selectedState, setSelectedState] = useState(() =>
    getSelectedStateId(customerState),
  );

  useEffect(() => {
    const newSelectedState = getSelectedStateId(customerState);
    setSelectedState(newSelectedState);
  }, [customerState, getSelectedStateId]);

  const onStateChange = (item: CustomerStateItem) => {
    setSelectedState(item.id);
    setCustomerState(item.state);
  };

  return (
    <AssemblyButtonGroup>
      {CUSTOMER_STATE_ITEMS.map((item) => (
        <AssemblyButton
          key={item.id}
          variant={selectedState === item.id ? 'contained' : 'outlined'}
          onClick={() => onStateChange(item)}>
          {item.label}
        </AssemblyButton>
      ))}
    </AssemblyButtonGroup>
  );
};
